import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["ratioDisplay"]

  connect() {
    this.updateRatioDisplay()
  }

  updateRatioDisplay(event) {
    const ratio = event ? event.target.value : 0.5
    const percentage = Math.round(ratio * 100)
    if (this.hasRatioDisplayTarget) {
      this.ratioDisplayTarget.textContent = `${percentage}%`
    }
  }

  fillExample(event) {
    const example = event.currentTarget.dataset.example
    const queryInput = document.querySelector('input[name="query"]')
    if (queryInput) {
      queryInput.value = example
      queryInput.focus()
    }
  }
}